import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import { Spin, Tabs, Row, Col, Tag, message, Affix, Table, Divider, Modal, Space, Popconfirm } from 'antd';
import ReconcilerGroupDetail from './reconcilers_detail';
import { COLORS } from '../theme';
import { showErrorInNotification, formatMoney, showSuccessInNotification } from '../../lib/util';
import { PopUpForm } from '../../lib/ui/popupform';
import SourceDatatypeList from '../settings/groups/source_datatype_list';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { ExitToApp, SentimentDissatisfied, SentimentSatisfied, Mood, DoneAll, History, Refresh } from '@material-ui/icons';
import { IconNoCard, TransparentButton } from '../../components/basic_items';
import SourceClosingHistory from './source_closing_history';

function getRandomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

// const mock_data1 = [];
// Array(30 * 3).fill("").map((item, index) => {
//     console.log("filling", index, parseInt(index / 3))
//     let item_number = parseInt(index / 3);
//     mock_data1.push({
//         txn_date: moment().subtract({ day: item_number }).format("YYYY-MM-DD"),
//         name: `Datatype ${item_number}`,
//         dr_count: getRandomInt(400),
//         dr_total: getRandomInt(40000),
//         cr_count: getRandomInt(200),
//         cr_total: getRandomInt(50000)
//     })
// })


const queryString = require('query-string');

class GroupSourceDetail extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true, source_obj: {},
            selected_source_id: null,
            selected_source_label: '',
            form_data: {},
            tab: null,
            isClosing: false,
            closing_data: {},
            view_history_modal: false
        }
        this.group_id = props.match.params.group_id;
        this.source_id = props.match.params.source_id;

        this.detail_source = RESTExecutor.detail().forId(this.source_id).config({
            label: 'groupsourcedetail'
        }).callbacks((success) => {
            let reconcilers = success.result.reconcilers || [];
            let first_reconciler = reconcilers[0] || {};
            if (this.state.tab == null) {
                this.setState({
                    tab: first_reconciler.id
                })
            }
            // make first id default tab if not done previously

            this.setState({ loading: false, source_obj: success.result })
        }, (error) => {
            this.setState({ loading: false })
        }).connect(props.domains.usergroups);


        this.add_source_label = RESTExecutor.post().config({
            url: '/my-group-source-labels'
        }).callbacks((success) => {
            message.success("Source Label Added");
            this.setState({
                selected_source_id: null,
                selected_source_label: ''
            })
            this.detail_source.execute();
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.usergroups);

        this.remove_source_label = RESTExecutor.delete().config({
            url: '/my-group-source-labels'
        }).callbacks((success) => {
            message.success("Source Label Removed");
            this.setState({
                selected_source_id: null,
                selected_source_label: ''
            })
            this.detail_source.execute();
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.usergroups);

        this.close_source = RESTExecutor.post().config({
            label: 'close_source'
        }).callbacks((success) => {
            showSuccessInNotification(success);
            this.setState({
                closing_data: {},
                isClosing: false
            });
            this.detail_source.execute()
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.usergroups);

        this.run_source_for_reconciler = RESTExecutor.post().config({
            label: 'run_source_for_reconciler',
            params: {}
        }).callbacks((success) => {
            try {
                this.loading_message();
            } catch (e) {

            }
            showSuccessInNotification(success, "Operation Completed")
        }, (error) => {
            try {
                this.loading_message();
            } catch (e) {

            }
            showErrorInNotification(error)
        }).connect(props.domains.usergroups);

    }

    render() {
        let detail_source_resp = this.detail_source.response();
        let add_source_label_resp = this.add_source_label.response();
        let close_source_resp = this.close_source.response();
        let run_source_for_reconciler_resp = this.run_source_for_reconciler.response();



        const { loading, source_obj, tab, selected_source_id, selected_source_label, form_data, isClosing, closing_data } = this.state;
        let reconcilers = source_obj.recon_overview || [];
        let data_types = source_obj.data_types || [];
        let labels = source_obj.labels || [];
        let date_overview = source_obj.date_overview || [];
        if (loading) {
            return <center><Spin /></center>
        }
        // let total_datatype = last_30_days.length / 30;


        // let getRowSpan = (index) => {
        //     let _rowSpan = 0;
        //     let previous_data = last_30_days[index - 1] || {};
        //     let next_data = last_30_days[index + 1] || {};
        //     let row = last_30_days[index] || {};



        //     if (previous_data.txn_date != row.txn_date) {
        //         _rowSpan = total_datatype
        //     }
        //     return _rowSpan
        // }




        return (<ErrorWrapper
            error={detail_source_resp}
            onReload={() => {
                this.setState({ loading: true, source_obj: {} })
                this.detail_source.forId(this.source_id).execute()
            }}
        >
            <BasicHeader
                title={source_obj.group_name}
                titleType="Group"
                subtitle={source_obj.name}
                subtitleType="Source"
                right={[
                    <TransparentButton
                        label={"Close Source"}
                        icon={<DoneAll />}
                        hint="Close Source"
                        disabled={close_source_resp.fetching}
                        onClick={() => {
                            this.setState({
                                isClosing: true
                            })
                        }}
                    // icon={archived?<UnarchiveOutlined/>:<ArchiveOutlined/>}
                    // hint={archived?"Unarchive Report":"Archive Report"}
                    />,
                    <TransparentButton
                        label={"Closing History"}
                        icon={<History />}
                        hint="View Previous Closing History"
                        onClick={() => {
                            this.setState({
                                view_history_modal: true
                            })
                        }}
                    // icon={archived?<UnarchiveOutlined/>:<ArchiveOutlined/>}
                    // hint={archived?"Unarchive Report":"Archive Report"}
                    />
                ]}
            />

            <PopUpForm
                title={`Assign Label For ${selected_source_label}`}
                show_title_only
                forCreate={true}
                initialData={form_data}
                fields={[
                    { index: 'label_id', display_key: 'label', type: 'networkselect', name: "Label", url: `/my-group-source-labels?group_id=${this.group_id}&source_id=${selected_source_id}` },
                ]}
                open={selected_source_id != null}
                networkState={add_source_label_resp}
                onClose={() => this.setState({ selected_source_id: null, selected_source_label: '' })}
                onSubmit={(data) => {
                    console.log("DATA", data);
                    this.add_source_label.execute({
                        ...data,
                        group_source_id: selected_source_id
                    })
                    // this.handlePostPatch(data);
                }} />


            <PopUpForm
                title={`Close source For ${source_obj.name}`}
                show_title_only
                forCreate={true}
                initialData={closing_data}
                fields={[
                    { index: 'txn_date', type: 'date', name: "Close Upto", disabledTo: source_obj.closed_date },
                    { index: 'close_note', type: 'textarea', name: "Closing Note" }
                ]}
                open={isClosing}
                networkState={close_source_resp}
                onClose={() => this.setState({ isClosing: false })}
                onSubmit={(data) => {
                    console.log("DATA", data);
                    this.close_source.forId(this.source_id).execute({
                        ...data,
                    });
                    // this.handlePostPatch(data);
                }} />

            <Modal
                visible={this.state.view_history_modal}
                width="90%"
                destroyOnClose
                footer={null}
                className='transaction-modal'
                centered
                onCancel={() => {
                    this.setState({
                        view_history_modal: false,
                    })
                }}
            >
                <SourceClosingHistory
                    key={`${this.source_id}--`}
                    source_id={this.source_id}
                    onClose={() => {
                        this.setState({
                            view_history_modal: false,
                        })
                    }}
                />
            </Modal>


            <Row style={{
                paddingBottom: 40
            }}>
                <Col span={24}>
                    <Row>
                        <Col {...{ xs: 24, sm: 24, md: 18, lg: 18, xl: 18, xxl: 18 }} style={{
                            padding: 8
                        }}>
                            <SourceDatatypeList
                                data_types={data_types}
                                key={`${this.source_id}--`}
                                source_id={this.source_id}
                            />
                        </Col>
                        <Col {...{ xs: 24, sm: 24, md: 6, lg: 6, xl: 6, xxl: 6 }} style={{
                            padding: 8
                        }}>
                            <div
                                className='default-card'
                                style={{
                                    margin: 0,
                                    padding: 0,
                                    // height: '100%',
                                    paddingTop: 16,
                                    paddingBottom: 16,
                                    height: '100%'
                                }}>
                                <div style={{
                                    paddingLeft: 30,
                                    paddingRight: 30,
                                }}>
                                    <div className='sub-heading-1' style={{
                                        color: COLORS.secondary,
                                        marginBottom: 12
                                    }}>Source Info</div>

                                    <div>
                                        <div style={{
                                            color: COLORS.secondary,
                                        }}>Last Closed : {source_obj.closed_date || "Not Closed Yet"}</div>

                                        <div className='sub-heading-3' style={{
                                            color: COLORS.secondary,
                                            marginTop:12

                                        }}>LABELS</div>
                                        <div style={{
                                            paddingTop: 6,
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            paddingRight: 12,

                                        }}>
                                            {labels.map((item) => {
                                                return <Tag closable onClose={(e) => {
                                                    e.preventDefault()
                                                    this.remove_source_label.config({
                                                        url: `/my-group-source-labels/${item.id}`
                                                    }).execute()
                                                }} className='tag-orange' style={{ marginRight: 6, marginBottom: 4 }}>{item.label}</Tag>
                                            })}
                                            <Tag title="Add New Label" className='dashed-tag hand-cursor'
                                                onClick={() => {
                                                    this.setState({
                                                        selected_source_id: this.source_id,
                                                        selected_source_label: source_obj.name
                                                    });
                                                }}
                                                style={{ marginRight: 6, marginBottom: 4, backgroundColor: 'transparent' }}>+ Add Label</Tag>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>




                <Col span={24} >
                    <div
                        className='default-card'
                        style={{
                            // margin: 0,
                            padding: 0,
                            // height: '100%',
                            paddingTop: 16,
                            paddingBottom: 16
                        }}>
                        <div style={{
                            paddingLeft: 30,
                            paddingRight: 30,
                        }}>
                            <span className='sub-heading-1' style={{
                                color: COLORS.secondary,
                                marginBottom: 12
                            }}>Reconcilers</span>
                        </div>


                        {/* <Divider> */}

                        {/* </Divider> */}
                        {reconcilers.map((item, index) => {
                            let total_pending = item.pending || 0;
                            let week_status = item.reconciled_week || {};
                            let unreconciled = item.unreconciled || 0

                            return <>
                                <div style={{
                                    width: '100%',
                                    paddingLeft: 30,
                                    paddingRight: 30
                                }}>



                                    <Row type='flex' align='middle' style={{
                                        flexWrap: 'wrap'
                                    }}>
                                        <Col {...{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }} style={{ padding: 8 }}>
                                            <div style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                flexWrap: 'nowrap'
                                            }}>

                                                <Link to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${item.id}`}>
                                                    <span className='sub-heading-2' style={{
                                                        color: COLORS.primary
                                                    }}>{item.name}</span>
                                                </Link>
                                                <Popconfirm
                                                    disabled={run_source_for_reconciler_resp.fetching}
                                                    onConfirm={() => {
                                                        this.loading_message = message.loading(`Running ${item.name} for ${source_obj.name}`, 0);
                                                        this.run_source_for_reconciler.config({
                                                            params: {
                                                                source_id: this.source_id,
                                                                reconciler_id: item.id
                                                            }
                                                        }).execute();
                                                    }}
                                                    title={<span>Are you sure you want to run <b>{item.name}</b> for <b>{source_obj.name}</b>?</span>}
                                                >
                                                    <Refresh className='hand-cursor'
                                                        titleAccess="Rerun"
                                                        style={{
                                                            height: 20,
                                                            color: COLORS.primary,
                                                            width: 20,
                                                            marginLeft: 12
                                                        }} /></Popconfirm>


                                            </div>
                                            <div className='sub-heading-3 ' style={{
                                                color: COLORS.secondary
                                            }}>Last Reconciled : {item.reconciled_at}</div>
                                        </Col>

                                        <Col {...{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }} style={{ padding: 8 }}>
                                            <IconNoCard
                                                type='success'
                                                icon={<Mood />}
                                                title={week_status.txncount > 10000 ? "10,000+" : formatMoney(week_status.txncount, 0)}

                                                subtitle="Reconciled Txns (Last 7 days)"
                                                link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${item.id}/reconciled`}
                                                style={{
                                                    height: '100%',
                                                }}
                                            />
                                        </Col>
                                        <Col {...{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }} style={{ padding: 8 }}>

                                            <IconNoCard
                                                type='warning'
                                                icon={<SentimentSatisfied />}
                                                title={total_pending > 10000 ? "10,000+" : formatMoney(total_pending, 0)}
                                                subtitle="Pending Txns"
                                                link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${item.id}/pending`}
                                                style={{
                                                    height: '100%',
                                                }}
                                            />
                                        </Col>
                                        <Col {...{ xs: 24, sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }} style={{ padding: 8 }}>

                                            <IconNoCard
                                                type='danger'
                                                icon={<SentimentDissatisfied />}
                                                title={formatMoney(unreconciled, 0)}
                                                subtitle="Unreconciled Txns"
                                                link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${item.id}/unreconciled`}
                                                style={{
                                                    height: '100%',
                                                }}
                                            />
                                        </Col>
                                    </Row>


                                </div>
                                {index != reconcilers.length - 1 && <Divider style={{ margin: 0 }} />}
                            </>

                        })}
                    </div></Col>


                <Col span={24} style={{
                    padding: 8
                }} >
                    <div
                        // className='default-card'
                        style={{
                            margin: 0,
                            paddingTop: 0,
                            // paddingBottom: 20,
                            backgroundColor: 'transparent',
                            borderRadius: 6
                            // height: '100%'
                        }}>
                        <div style={{
                            paddingTop: 20,
                            paddingBottom: 12,
                            backgroundColor: 'white'
                        }}>
                            <span className='sub-heading-1' style={{
                                color: COLORS.secondary,
                                paddingLeft: 30
                            }}>Last {date_overview.length} days</span>
                        </div>

                        <div
                            // className='default-card'
                            style={{
                                margin: 0,
                                padding: 0
                                // display: 'flex',
                                // flexDirection: 'row',
                                // alignItems: 'center',
                                // flexWrap: 'wrap'
                            }}>
                            <Table
                                className='main-table  noHover customCardTable1'
                                bordered={false}
                                columns={[
                                    {
                                        title: "TXN DATE", key: 'txn_date', dataIndex: 'txn_date',
                                        render: (value, row, index) => {
                                            const obj = {
                                                children: value,
                                                props: {
                                                },
                                            };
                                            // let previous_data = last_30_days[index - 1] || {};
                                            // let next_data = last_30_days[index + 1] || {};

                                            // if (previous_data.txn_date != row.txn_date) {
                                            //     obj.children = value
                                            // }
                                            // if (previous_data.txn_date != row.txn_date && next_data.txn_date == row.txn_date) {
                                            //     obj.children = value;
                                            //     obj.props.className = 'cell-no-bottom-border'
                                            // }

                                            // if (next_data.txn_date == row.txn_date && previous_data.txn_date == row.txn_date) {
                                            //     obj.props.className = 'cell-no-bottom-border'
                                            // }
                                            return obj;
                                        }
                                    },
                                    {
                                        title: "DATATYPE",
                                        key: 'datatype',
                                        dataIndex: 'data_types',
                                        className: 'padding-left',
                                        render: (datatypes = [], record, index) => {

                                            return <div style={{
                                                display: 'flex',
                                                flexDirection: 'column'
                                            }}>
                                                {datatypes.map((item, index) => {
                                                    let value = item.data_type_name
                                                    return <div style={{
                                                        marginTop: index == 0 ? 0 : 8
                                                    }}>{value}</div>
                                                })}
                                            </div>
                                        }
                                    },
                                    {
                                        title: "DR COUNT",
                                        dataIndex: 'data_types',
                                        key: 'dr_count',
                                        className: 'right-align padding-right',
                                        render: (datatypes = [], record) => <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-end'
                                        }}>
                                            {datatypes.map((item, index) => {
                                                let value = item.dr_count;
                                                return value > 0 ? <Link style={{
                                                    marginTop: index == 0 ? 0 : 8
                                                }} to={{
                                                    pathname: `/activity/data-type/${item.data_type_id}/transactions`,
                                                    search: queryString.stringify({
                                                        source: item.label,
                                                        dateFrom: record.txn_date,
                                                        dateTo: record.txn_date,
                                                        txn_type: "D"

                                                    })
                                                }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> :
                                                    <span className='right-align' style={{
                                                        marginTop: index == 0 ? 0 : 8
                                                    }}>{formatMoney(value, 0)}</span>
                                            })}

                                        </div>
                                    },
                                    {
                                        title: "DR TOTAL",
                                        dataIndex: 'data_types',
                                        key: 'dr_total',
                                        className: 'right-align padding-right',
                                        render: (datatypes, record) => <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-end'
                                        }}>
                                            {datatypes.map((item, index) => {
                                                let value = item.dr_total;

                                                return <span style={{
                                                    marginTop: index == 0 ? 0 : 8
                                                }} className='right-align'>{formatMoney(value, 2)}</span>
                                            })}

                                            {/* } */}
                                        </div>
                                    },
                                    {
                                        title: "CR COUNT",
                                        dataIndex: 'data_types',
                                        key: 'cr_count',
                                        className: 'right-align padding-right',
                                        render: (datatypes = [], record) => <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-end'
                                        }}>
                                            {datatypes.map((item, index) => {
                                                let value = item.cr_count;
                                                return value > 0 ? <Link style={{
                                                    marginTop: index == 0 ? 0 : 8
                                                }} to={{
                                                    pathname: `/activity/data-type/${item.data_type_id}/transactions`,
                                                    search: queryString.stringify({
                                                        source: item.label,
                                                        dateFrom: record.txn_date,
                                                        dateTo: record.txn_date,
                                                        txn_type: "C"

                                                    })
                                                }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> :
                                                    <span className='right-align' style={{
                                                        marginTop: index == 0 ? 0 : 8
                                                    }}>{formatMoney(value, 0)}</span>
                                            })}
                                        </div>
                                    },
                                    {
                                        title: "CR TOTAL",
                                        dataIndex: 'data_types',
                                        key: 'cr_total',
                                        className: 'right-align padding-right',
                                        render: (datatypes = [], record) => <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-end'
                                        }}>
                                            {datatypes.map((item, index) => {
                                                let value = item.cr_total;

                                                return <span style={{
                                                    marginTop: index == 0 ? 0 : 8
                                                }} className='right-align'>{formatMoney(value, 2)}</span>
                                            })}
                                        </div>
                                    }
                                ]}
                                pagination={false}
                                size='small'
                                dataSource={date_overview}
                            />
                        </div></div></Col>





            </Row>

            {/* <div style={{
                paddingTop: 64
            }}>
                {reconcilers.length > 0 ?
                    <Affix offsetTop={0} onChange={(affixed) => {
                        console.log("some changes", affixed)
                        this.setState({ tabFixedTop: affixed })
                    }}>
                        <Tabs

                            style={{ height: 'calc(100vh + 1px)' }}
                            renderTabBar={(props, DefaultTabBar) => {
                                return <DefaultTabBar {...props} className='sticky-content' style={{
                                    backgroundColor: COLORS.main_bg_color,
                                    padding: 8
                                }} />
                            }}
                            tabPosition='top' activeKey={tab}
                            onTabClick={(tab) => {
                                this.props.history.push({
                                    search: queryString.stringify({ tab: tab })
                                })
                            }}>
                            {
                                reconcilers.map((item) => {
                                    return <Tabs.TabPane key={item.id}

                                        tab={item.name}

                                    >
                                        <div style={{
                                            height: this.state.tabFixedTop ? 'calc(100vh - 64px)' : null,
                                            overflowY: this.state.tabFixedTop ? 'scroll' : null
                                        }}>
                                            <ReconcilerGroupDetail
                                                match={{
                                                    params: {
                                                        reconciler_id: item.id,
                                                        source_id: this.source_id,
                                                        group_id: this.group_id
                                                    }
                                                }}
                                            />
                                        </div>

                                    </Tabs.TabPane>
                                })
                            }

                        </Tabs>
                    </Affix>
                    :
                    <div>
                        No any reconcilers
            </div>
                }
            </div> */}


        </ErrorWrapper >
        );
    }

    componentDidMount() {

        let new_filter_query = {};
        if (this.props.location && this.props.location.search) {
            const parsed = queryString.parse(this.props.location.search);
            new_filter_query = parsed;
        }
        if (new_filter_query.tab != null) {
            this.setState({
                tab: new_filter_query.tab
            })
        }
        console.log("did mount filter", new_filter_query)

        this.detail_source.execute();
    }
    componentWillUnmount() {
        try {
            this.loading_message()
        } catch (e) {

        }
    }

    componentWillReceiveProps(nextProps) {
        var oldsource_id = this.props.match.params.source_id;
        var newsource_id = nextProps.match.params.source_id;
        // if(oldsource_id!==newsource_id){
        //     this.source_id=newsource_id;
        //     this.setState({
        //         loading:true,
        //         source_obj:{}
        //     });
        //     this.detail_source.forId(this.source_id).execute()
        // }

        if (oldsource_id !== newsource_id || (
            this.props.location && (this.props.location.search !== nextProps.location.search)
        )) {
            this.source_id = newsource_id;
            const parsed = queryString.parse(nextProps.location.search);

            if ((oldsource_id !== newsource_id)) {
                // fetch new source
                this.setState({
                    loading: true,
                    source_obj: {}
                });
                this.detail_source.forId(this.source_id).execute()
            } else {
                // change tab only
                if (parsed.tab != null) {
                    this.setState({ tab: parsed.tab })
                }
            }
        }


    }

}

export default withDomains(GroupSourceDetail, "usergroups");
